import { useRouter } from 'next/router';
import { useEffect } from 'react';

/**
 * Apply scroll-smooth style only when it's needed
 */
const useSmoothScroll = () => {
  const router = useRouter();

  useEffect(() => {
    const removeClass = () => {
      document.documentElement.classList.remove('scroll-smooth');
    };

    if (document) {
      document.documentElement.classList.add('scroll-smooth');
    }

    /** class should be removed before actual transition starts */
    router.events.on('routeChangeStart', removeClass);

    return () => router.events.off('routeChangeStart', removeClass);
  }, [router]);
};

export default useSmoothScroll;
